const config = {
  development: {
    proxy: 'https://stagingregistrar.velocitynetwork.foundation'
  },
  production: {
    proxy: 'https://stagingregistrar.velocitynetwork.foundation' // You can change this to your production API URL
  }
};
export const tableToName = {
  "ocelot_knowledge_base": "Ocelot FAQ",
  "course_catalog": "Course Catalog",
  "documents": "MDC Website",
  "course_sequencing": "Course Sequencing Guides"
}
const defaultSettings = [
  {
    table_name: "ocelot_knowledge_base",
    match_threshold: 0.55,
    match_count: 10
  },
  {
    table_name: "course_sequencing",
    match_threshold: 0.51,
    match_count: 10
  },
  {
    table_name: "course_catalog",
    match_threshold: 0.5,
    match_count: 10
  },
  {
    table_name: "documents",
    match_threshold: 0.5,
    match_count: 10
  }
];
export const getDefaultSettings = () => {
  if(localStorage.getItem('RAG_SETTINGS')){
      return JSON.parse(localStorage.getItem('RAG_SETTINGS'));
  }
  return defaultSettings;
}

// Returns the built-in defaults regardless of localStorage
export const getFactoryDefaultSettings = () => {
  try {
    return JSON.parse(JSON.stringify(defaultSettings));
  } catch (e) {
    return defaultSettings;
  }
}

export const getConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return config[env];
};

export default config; 